import React from 'react'
import { Box, CircularProgress } from '@mui/material/'

function AppSpinner() {
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  )
}

export default AppSpinner
